module.exports = __webpack_public_path__ + "img/upload.c247cbfd.svg";